import PaddedSpinner from '../util/PaddedSpinner';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

interface ContentLoadWrapperProps {
  children: React.JSX.Element;
}

const ContentLoadWrapper = observer((props: ContentLoadWrapperProps): React.JSX.Element => {
  const { children } = props;
  const {
    translateStore: { fetched },
  } = useStores();

  if (!fetched) {
    return <PaddedSpinner />;
  }
  return children;
});

export default ContentLoadWrapper;
